import { useEffect } from 'react'
// FOR PAGE ROUTING
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom'

import './App.css';
import './vars.css';

import ScrollToTop from './components/utility/ScrollToTop';
import Error from './components/pages/error/Error';
import Loading from './components/utility/Loading'; //HOW TO GET TO BE INBETWEEN PAGES
import Home from './components/pages/home/Home';
import Photo from './components/pages/photo/PhotoPage';
// import Proj from './components/pages/projects/Proj'


function App() {
  // const [loading, setLoading] = useState(true);
  
  useEffect(() => {

  }, [])

  return (
    <div className='hello'>
      <Router>
        <ScrollToTop />
          <Routes>
            {/* <Route path={'/'} element={<Loading />} /> */}
            <Route path={'*'} element={<Error />} />
            <Route path={'/'} element={<Home />} />
            <Route path={'/Photo'} element={<Photo />} />
          </Routes>
      </Router>
    </div>
  )
}

export default App;